import { LoginCredentialsPage } from "@/features/auth/pages/LoginCredentials";
import { withGuest } from "@/hoc/withGuest";

const LoginCredentials = () => {
  return <LoginCredentialsPage />;
};

export default withGuest(LoginCredentials);
